import React from 'react';
import PropTypes from 'prop-types';
import styles from './ResultTableTab.module.css';

const ResultTableTab = ({
  dataTypeOptions = [],
  optionValues,
  handleOptionChange,
}) => {
  if (!dataTypeOptions.length) return null;
  return (
    <div className={styles.options}>
      {dataTypeOptions.map((option) => (
        <div
          key={option.value}
          className={`${styles.option} ${optionValues['dataType'] === option.value ? styles.active : ''}`}
          onClick={() => {
            if (dataTypeOptions.length > 1) {
              handleOptionChange('dataType', option.value);
            }
          }}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

ResultTableTab.propTypes = {
  dataTypeOptions: PropTypes.arrayOf(PropTypes.object),
  optionValues: PropTypes.object,
  handleOptionChange: PropTypes.func,
};

export default ResultTableTab;
